export default __webpack_public_path__ + "static/media/03.36774bca.png";